export default "__VITE_ASSET__BkJ3leWm__"